import React from "react";

const resolveWorkAuthName = (value, map) => {
  if (!value) return "";
  const key = String(value).trim();
  if (!key || key === "0") return "";
  if (map?.[key]) return map[key];
  if (/^\d+$/.test(key)) {
    const normalized = String(Number(key));
    if (map?.[normalized]) return map[normalized];
  }
  const matchKey = Object.keys(map || {}).find(
    (mapKey) => map?.[mapKey] === key,
  );
  if (matchKey) return map[matchKey];
  if (/^\d+$/.test(key)) return "";
  return key;
};

const WorkAuthorizationLabel = ({ workAuthValue, workAuthMap, fallback = "" }) => {
  const resolved = resolveWorkAuthName(workAuthValue, workAuthMap);
  return resolved ? <span>{resolved}</span> : fallback;
};

export default WorkAuthorizationLabel;
